import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, KeyValues10, LocalService, NumericConfig, OtpType, PaymentGatewayServiceType, Status } from 'src/service/local.service';
import { QrPaymentService } from 'src/service/qr-payment.service';

@Component({
  selector: 'app-edit-payment-gateway-config',
  templateUrl: './edit-payment-gateway-config.component.html',
  styleUrl: './edit-payment-gateway-config.component.scss'
})
export class EditPaymentGatewayConfigComponent {
  @ViewChild('content_payment_gateway_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = ''; @Input() countryCode: string = '';
  @Input() gatewayType: PaymentGatewayServiceType;
  @Input() id: string = '';

  contactPrefix: string = ''; isMobileOtpVerified: boolean = false; contactLength: number = 0;
  otpType = OtpType; isShowMobileOtpPopup = false;
  htmlId: string = ''; elementIds: any;

  configData: KeyValues10;
  numericConfig: NumericConfig = {} as NumericConfig;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private qrPaymentService: QrPaymentService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_save: 'btn_save_' + this.htmlId,
      salt_key: 'salt_key_' + this.htmlId,
      merch_id: 'merch_id_' + this.htmlId,
      title: 'title_' + this.htmlId,
      contact: 'contact_' + this.htmlId,
      verify_contact: 'verify_contact_' + this.htmlId,
      salt_idx: 'salt_idx_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {
    this.contactPrefix = this.localService.getContactPrefixByCountryCode(this.localService.getLoginAsCountryCode() );
    this.contactLength = this.localService.getContactMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() );
    this.numericConfig.maxDigits = this.contactLength;
    this.onLoad();
  }

  onLoad() {
    this.qrPaymentService.getQrPaymentConfig(this.localService.getLoginAsCountryCode() , this.businessId, this.gatewayType, this.id).subscribe(result => {
      this.configData = result;
      if (this.configData.key) {
        this.isMobileOtpVerified = true;
      }
      this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
    });
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
      case 2: {
        if (this.isShowMobileOtpPopup) {
          this.isShowMobileOtpPopup = false;
          setTimeout(() => {
            this.isShowMobileOtpPopup = true;
          }, 500);
        } else {
          this.isShowMobileOtpPopup = true;
        }
      } break;
    }
  }

  onSave() {
    this.qrPaymentService.saveQrPaymentConfig(this.configData).subscribe(result => {
      this.localService.showInformationByStatus(result.status, result.status != Status.Success);
      if (result.status == Status.Success) {
        this.onCloseTrigger();
      }
    });
  }

  onVerifiedOtp(e, otpType: OtpType) {
    switch (otpType) {
      case OtpType.MobileVerification: {
        this.isMobileOtpVerified = true;
      } break;
    }
    this.isShowMobileOtpPopup = false;
  }
}
